<div class="title-container">
  <h4>{{ lod }}</h4>
  <input #input (blur)="deleteTrim(input.value, input)" (input)="getText(input.value, input)" [(ngModel)]="lod_type"
    type="text" />
</div>
<hr />

<!-- <app-title-block></app-title-block> -->

<!-- ! Generated view container -->
<div class="container center">
  <ng-container #view>
  </ng-container>
</div>

<div class="title-container">
  <p-button (onClick)="generate()" label="Agregar bloque de preguntas" icon="pi pi-plus" [rounded]="true"
    severity="success" [style]="{ 'border-radius': '40px' }"></p-button>
</div>

<div style="text-align:center" *ngIf="lob?.name=='Ambiente y Regulación'">
  <h4>Tiene contenedor de locaciones?(*)</h4>
  
  <div class="justify-content-center" style="margin-top: 10px;">
    <p-toggleButton [(ngModel)]="checked" onLabel="Contiene" offLabel="No Contiene" styleClass="w-9rem"
       />
  </div>
</div>